<template>
    <div class="section pt-2 pb-5">
        <div class="section-title mal-text" style="font-size:16px;font-weight:800;color:#1a418c;margin-bottom:10px;">
            QHLS Final Exam Centers
        </div>

        <!-- Tabs -->
        <div style="display:flex;gap:6px;margin-bottom:12px;">
            <button @click="tab='centers'" class="qtab" :style="tabStyle(tab==='centers')">
                <ion-icon name="business-outline"></ion-icon>
                <span>Manage Centers</span>
            </button>
            <button @click="switchToAssign()" class="qtab" :style="tabStyle(tab==='assign')">
                <ion-icon name="people-outline"></ion-icon>
                <span>Assign Candidates</span>
            </button>
            <button v-if="user_level===1" @click="switchToReport()" class="qtab" :style="tabStyle(tab==='report')">
                <ion-icon name="bar-chart-outline"></ion-icon>
                <span>Report</span>
            </button>
        </div>

        <!-- ===================== TAB: CENTERS ===================== -->
        <template v-if="tab==='centers'">
            <!-- Add form -->
            <div class="card p-3 mb-3" style="border-radius:12px;">
                <div style="font-size:13px;font-weight:700;color:#1a418c;margin-bottom:10px;" class="mal-text">പുതിയ സെന്റർ ചേർക്കുക</div>
                <label class="field-label">Centre Name *</label>
                <input v-model="newCenter.name" type="text" class="form-control form-control-sm mb-2" placeholder="Enter centre name" />
                <label class="field-label">Centre Name (English)</label>
                <input v-model="newCenter.name_en" type="text" class="form-control form-control-sm mb-2" placeholder="Used on the hall ticket PDF" />
                <label class="field-label">Place</label>
                <input v-model="newCenter.location" type="text" class="form-control form-control-sm mb-2" placeholder="Enter place / location" />
                <template v-if="user_level===1">
                    <label class="field-label">District *</label>
                    <select v-model="newCenter.district_id" class="form-select form-select-sm mb-2">
                        <option value="">— Select District —</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                </template>

                <!-- Coordinator -->
                <label class="field-label">Coordinator Name</label>
                <input v-model="newCenter.coordinator_name" type="text" class="form-control form-control-sm mb-2" placeholder="Enter coordinator name" />
                <label class="field-label">Coordinator Mobile</label>
                <input v-model="newCenter.coordinator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <!-- Invigilator -->
                <label class="field-label">Invigilator Name</label>
                <input v-model="newCenter.invigilator_name" type="text" class="form-control form-control-sm mb-2" placeholder="Enter invigilator name" />
                <label class="field-label">Invigilator Mobile</label>
                <input v-model="newCenter.invigilator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <button @click="addCenter" :disabled="addingCenter || !newCenter.name.trim() || (user_level===1 && !newCenter.district_id)"
                    class="btn btn-primary btn-sm w-100" style="border-radius:8px;">
                    <span v-if="addingCenter" class="spinner-border spinner-border-sm me-1"></span>
                    <ion-icon v-else name="add-circle-outline" class="me-1"></ion-icon>
                    Add Center
                </button>
            </div>

            <!-- Centers list -->
            <div v-if="loadingCenters" class="text-center py-3"><div class="spinner-border text-primary"></div></div>
            <div v-else-if="!centers.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">ഒരു സെന്ററും ചേർത്തിട്ടില്ല</div>
            <div v-else style="display:flex;flex-direction:column;gap:8px;">
                <div v-for="c in centers" :key="c.id" style="background:#fff;border-radius:12px;padding:12px 14px;border:1px solid #eef0f5;">
                    <div style="display:flex;align-items:flex-start;gap:8px;">
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:14px;font-weight:800;color:#1e293b;">{{ c.name }}</div>
                            <div v-if="!c.name_en" style="font-size:11px;color:#e67e22;margin-top:2px;">
                                <ion-icon name="alert-circle-outline" style="font-size:11px;"></ion-icon> No English name set — hall ticket PDF will fall back to Malayalam
                            </div>
                            <div v-else style="font-size:12px;color:#64748b;margin-top:2px;">{{ c.name_en }}</div>
                            <div v-if="c.location" style="font-size:12px;color:#64748b;margin-top:2px;">
                                <ion-icon name="location-outline" style="font-size:11px;"></ion-icon> {{ c.location }}
                            </div>
                            <div v-if="c.coordinator_name" style="font-size:12px;color:#1a418c;margin-top:3px;">
                                <ion-icon name="person-outline" style="font-size:11px;"></ion-icon>
                                {{ c.coordinator_name }}<span v-if="c.coordinator_mobile"> · {{ c.coordinator_mobile }}</span>
                            </div>
                            <div v-if="c.invigilator_name" style="font-size:12px;color:#2e7d32;margin-top:2px;">
                                <ion-icon name="eye-outline" style="font-size:11px;"></ion-icon>
                                {{ c.invigilator_name }}<span v-if="c.invigilator_mobile"> · {{ c.invigilator_mobile }}</span>
                            </div>
                        </div>
                        <!-- Actions -->
                        <div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0;">
                            <button @click="openEdit(c)"
                                style="display:inline-flex;align-items:center;gap:4px;background:#e8eeff;border:none;border-radius:8px;padding:5px 10px;color:#1a418c;font-size:12px;font-weight:600;cursor:pointer;">
                                <ion-icon name="pencil-outline" style="font-size:13px;"></ion-icon> Edit
                            </button>
                            <button @click="deleteCenter(c)"
                                style="display:inline-flex;align-items:center;gap:4px;background:#fff0f0;border:none;border-radius:8px;padding:5px 10px;color:#e74c3c;font-size:12px;font-weight:600;cursor:pointer;">
                                <ion-icon name="trash-outline" style="font-size:13px;"></ion-icon> Delete
                            </button>
                            <button @click="exportCandidatesPdf(c)" :disabled="pdfExportingId === c.id"
                                style="display:inline-flex;align-items:center;gap:4px;background:#eafaf1;border:none;border-radius:8px;padding:5px 10px;color:#12a85a;font-size:12px;font-weight:600;cursor:pointer;">
                                <span v-if="pdfExportingId === c.id" class="spinner-border spinner-border-sm" style="width:12px;height:12px;"></span>
                                <ion-icon v-else name="download-outline" style="font-size:13px;"></ion-icon> PDF
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- ===================== TAB: ASSIGN ===================== -->
        <template v-if="tab==='assign'">
            <div v-if="user_level===1" class="card p-2 mb-2" style="border-radius:12px;">
                <div style="display:flex;flex-direction:column;gap:8px;">
                    <select v-model="f_district" class="form-select form-select-sm" @change="onFDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-model="f_zone" class="form-select form-select-sm" @change="onFZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-model="f_center" class="form-select form-select-sm">
                        <option value="">All Centers</option>
                        <option v-for="c in qhlsCenters" :key="c.id" :value="c.id">{{ c.madrasa_name }}</option>
                    </select>
                    <button @click="loadQualified" class="btn btn-primary btn-sm" style="border-radius:8px;">
                        <span v-if="loadingQ" class="spinner-border spinner-border-sm me-1"></span>
                        <ion-icon v-else name="search-outline" class="me-1"></ion-icon> Search
                    </button>
                </div>
            </div>
            <div v-if="qualifiedLoaded" class="card mb-2" style="border-radius:12px;padding:10px 14px;background:#f0fff6;border:1px solid #b7f0d4;">
                <div style="display:flex;align-items:center;justify-content:space-between;">
                    <span style="font-size:13px;color:#1DCC70;font-weight:700;" class="mal-text">യോഗ്യർ (40+ മാർക്ക്)</span>
                    <span style="font-size:22px;font-weight:900;color:#1DCC70;">{{ qualified.length }}</span>
                </div>
            </div>
            <div v-if="qualifiedLoaded && qualified.length" style="position:relative;margin-bottom:10px;">
                <ion-icon name="search-outline" style="position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#94a3b8;font-size:16px;"></ion-icon>
                <input v-model="q_search" type="text" class="form-control form-control-sm"
                    placeholder="Search by name or mobile..."
                    style="padding-left:34px;border-radius:10px;" autocomplete="off" />
                <span v-if="q_search" @click="q_search=''"
                    style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#94a3b8;font-size:16px;cursor:pointer;">✕</span>
            </div>
            <div v-if="loadingQ" class="text-center py-4"><div class="spinner-border text-primary"></div></div>
            <div v-else-if="qualifiedLoaded && !qualified.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">യോഗ്യരായ വിദ്യാർത്ഥികൾ ഇല്ല</div>
            <div v-else-if="qualifiedLoaded && qualified.length && !filteredQualified.length" class="text-center text-muted py-3" style="font-size:13px;">No matching candidates found</div>
            <div v-else-if="filteredQualified.length" style="display:flex;flex-direction:column;gap:8px;">
                <div v-for="(item, idx) in filteredQualified" :key="item.registration_id"
                    style="background:#fff;border-radius:12px;padding:12px 14px;border:1px solid #eef0f5;">
                    <div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">
                        <div style="width:30px;height:30px;border-radius:50%;background:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                            <span style="color:#fff;font-size:11px;font-weight:800;">{{ idx+1 }}</span>
                        </div>
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:14px;font-weight:800;color:#1e293b;">{{ item.name }}</div>
                            <div style="font-size:11px;color:#64748b;">Written exam: {{ item.center_name || '—' }}<span v-if="item.zone_name"> · {{ item.zone_name }}</span></div>
                            <div v-if="item.mobile" style="font-size:11px;color:#64748b;margin-top:2px;">{{ item.mobile }}</div>
                        </div>
                        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;">
                            <div style="font-size:18px;font-weight:900;color:#1DCC70;">{{ item.effective_mark }}</div>
                            <div v-if="item.mobile" style="display:flex;gap:4px;">
                                <a :href="'https://wa.me/91' + item.mobile.replace(/\D/g,'')"
                                    target="_blank"
                                    style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:8px;background:#25D366;text-decoration:none;">
                                    <ion-icon name="logo-whatsapp" style="color:#fff;font-size:16px;"></ion-icon>
                                </a>
                                <a :href="'tel:' + item.mobile"
                                    style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:8px;background:#1a418c;text-decoration:none;">
                                    <ion-icon name="call-outline" style="color:#fff;font-size:16px;"></ion-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div style="font-size:10px;font-weight:700;color:#1a418c;text-transform:uppercase;letter-spacing:0.4px;margin-bottom:3px;">Final Exam Centre</div>
                    <div style="display:flex;align-items:center;gap:8px;">
                        <select v-model="item.final_center_id" class="form-select form-select-sm" style="flex:1;font-size:12px;" @change="assignCandidate(item)">
                            <option :value="null">— Not assigned yet —</option>
                            <option v-for="c in centers" :key="c.id" :value="c.id">{{ c.name }}</option>
                        </select>
                        <ion-icon v-if="item._saving" name="sync-outline" style="color:#1a418c;font-size:16px;animation:spin 1s linear infinite;"></ion-icon>
                        <ion-icon v-else-if="item._saved" name="checkmark-circle" style="color:#1DCC70;font-size:16px;"></ion-icon>
                        <span v-else-if="!item.final_center_id" style="font-size:10px;font-weight:700;color:#d9534f;white-space:nowrap;">Not assigned</span>
                    </div>
                </div>
            </div>
        </template>

        <!-- ===================== TAB: REPORT (state only) ===================== -->
        <template v-if="tab==='report'">
            <div v-if="loadingReport" class="text-center py-4"><div class="spinner-border text-primary"></div></div>
            <template v-else-if="reportLoaded">
                <!-- Summary cards -->
                <div style="display:grid;grid-template-columns:repeat(2,1fr);gap:8px;margin-bottom:12px;">
                    <div class="rcard" style="background:#eef2ff;border-color:#dbe3ff;">
                        <span class="rcard-label mal-text" style="color:#4b5fbd;">ആകെ സെന്ററുകൾ</span>
                        <span class="rcard-num" style="color:#1a418c;">{{ centers.length }}</span>
                    </div>
                    <div class="rcard" style="background:#f0fff6;border-color:#b7f0d4;">
                        <span class="rcard-label mal-text" style="color:#12a85a;">ആകെ വിദ്യാർത്ഥികൾ</span>
                        <span class="rcard-num" style="color:#1DCC70;">{{ reportScopedCandidates.length }}</span>
                    </div>
                    <div class="rcard" style="background:#eafaf1;border-color:#bfe9d0;">
                        <span class="rcard-label mal-text" style="color:#12a85a;">അസൈൻ ചെയ്തവർ</span>
                        <span class="rcard-num" style="color:#12a85a;">{{ reportAssignedCount }}</span>
                    </div>
                    <div class="rcard" style="background:#fff5f5;border-color:#f5c6c6;">
                        <span class="rcard-label mal-text" style="color:#d9534f;">അസൈൻ ചെയ്യാത്തവർ</span>
                        <span class="rcard-num" style="color:#d9534f;">{{ reportNotAssignedCount }}</span>
                    </div>
                </div>

                <!-- District filter -->
                <div style="margin-bottom:10px;">
                    <label class="field-label">Filter by District</label>
                    <select v-model="report_district_filter" class="form-select form-select-sm" style="border-radius:10px;"
                        @change="report_center_filter='all'">
                        <option value="all">All Districts ({{ reportCandidates.length }})</option>
                        <option v-for="d in reportDistrictOptions" :key="d.name" :value="d.name">{{ d.name }} ({{ d.count }})</option>
                    </select>
                </div>

                <!-- Centre-wise filter -->
                <div style="margin-bottom:10px;">
                    <label class="field-label">Filter by Centre</label>
                    <select v-model="report_center_filter" class="form-select form-select-sm" style="border-radius:10px;">
                        <option value="all">All Candidates ({{ reportScopedCandidates.length }})</option>
                        <option value="unassigned">— Not Assigned — ({{ reportNotAssignedCount }})</option>
                        <option v-for="c in reportPerCenter" :key="c.id" :value="c.id">{{ c.name }} ({{ c.count }})</option>
                    </select>
                </div>

                <!-- Search -->
                <div v-if="reportCandidates.length" style="position:relative;margin-bottom:10px;">
                    <ion-icon name="search-outline" style="position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#94a3b8;font-size:16px;"></ion-icon>
                    <input v-model="report_search" type="text" class="form-control form-control-sm"
                        placeholder="Search by name or mobile..." style="padding-left:34px;border-radius:10px;" autocomplete="off" />
                    <span v-if="report_search" @click="report_search=''"
                        style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#94a3b8;font-size:16px;cursor:pointer;">✕</span>
                </div>

                <div style="font-size:12px;color:#64748b;margin-bottom:6px;font-weight:600;">
                    {{ reportFilteredCandidates.length }} candidate(s)
                </div>

                <div v-if="!reportFilteredCandidates.length" class="text-center text-muted py-3" style="font-size:13px;">No candidates found</div>
                <div v-else style="display:flex;flex-direction:column;gap:8px;">
                    <div v-for="(item, idx) in reportFilteredCandidates" :key="item.registration_id"
                        style="background:#fff;border-radius:12px;padding:12px 14px;border:1px solid #eef0f5;">
                        <div style="display:flex;align-items:center;gap:10px;">
                            <div style="width:28px;height:28px;border-radius:50%;background:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                <span style="color:#fff;font-size:11px;font-weight:800;">{{ idx+1 }}</span>
                            </div>
                            <div style="flex:1;min-width:0;">
                                <div style="font-size:14px;font-weight:800;color:#1e293b;">{{ item.name }}</div>
                                <div style="font-size:11px;color:#64748b;">{{ item.center_name || '—' }}<span v-if="item.zone_name"> · {{ item.zone_name }}</span></div>
                                <div v-if="item.mobile" style="font-size:11px;color:#64748b;margin-top:2px;">{{ item.mobile }}</div>
                            </div>
                            <div style="display:flex;flex-direction:column;align-items:flex-end;gap:3px;flex-shrink:0;">
                                <div style="font-size:16px;font-weight:900;color:#1DCC70;">{{ item.effective_mark }}</div>
                                <span :style="item.final_center_id ? 'background:#eafaf1;color:#12a85a;' : 'background:#fff5f5;color:#d9534f;'"
                                    style="font-size:10px;font-weight:700;border-radius:6px;padding:1px 7px;white-space:nowrap;">
                                    {{ centerNameById(item.final_center_id) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>

        <!-- ===================== EDIT MODAL ===================== -->
        <div v-if="editTarget" style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:10000;display:flex;align-items:flex-end;justify-content:center;">
            <div style="background:#fff;border-radius:20px 20px 0 0;padding:20px;width:100%;max-width:480px;max-height:90vh;overflow-y:auto;">
                <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;">
                    <div style="font-size:15px;font-weight:800;color:#1a418c;">Edit Center</div>
                    <button @click="editTarget=null" style="background:#f1f5f9;border:none;border-radius:50%;width:30px;height:30px;font-size:16px;cursor:pointer;color:#64748b;">✕</button>
                </div>

                <label class="field-label">Centre Name *</label>
                <input v-model="editForm.name" type="text" class="form-control form-control-sm mb-2" placeholder="Centre name" />

                <label class="field-label">Centre Name (English)</label>
                <input v-model="editForm.name_en" type="text" class="form-control form-control-sm mb-2" placeholder="Used on the hall ticket PDF" />

                <label class="field-label">Place</label>
                <input v-model="editForm.location" type="text" class="form-control form-control-sm mb-2" placeholder="Place / location" />

                <!-- Coordinator -->
                <label class="field-label">Coordinator Name</label>
                <input v-model="editForm.coordinator_name" type="text" class="form-control form-control-sm mb-2" placeholder="Enter coordinator name" />
                <label class="field-label">Coordinator Mobile</label>
                <input v-model="editForm.coordinator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <!-- Invigilator -->
                <label class="field-label">Invigilator Name</label>
                <input v-model="editForm.invigilator_name" type="text" class="form-control form-control-sm mb-2" placeholder="Enter invigilator name" />
                <label class="field-label">Invigilator Mobile</label>
                <input v-model="editForm.invigilator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <div style="display:flex;gap:8px;margin-top:6px;">
                    <button @click="editTarget=null" class="btn btn-sm" style="flex:1;background:#f1f5f9;color:#1e293b;border:none;border-radius:8px;">Cancel</button>
                    <button @click="saveEdit" :disabled="savingEdit || !editForm.name.trim()" class="btn btn-primary btn-sm" style="flex:1;border-radius:8px;">
                        <span v-if="savingEdit" class="spinner-border spinner-border-sm me-1"></span>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>

        <!-- Delete confirm modal -->
        <div v-if="deleteTarget" style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:10000;display:flex;align-items:center;justify-content:center;padding:20px;">
            <div style="background:#fff;border-radius:16px;padding:24px;max-width:320px;width:100%;">
                <div style="font-size:15px;font-weight:700;color:#1e293b;margin-bottom:8px;">Delete Center?</div>
                <div style="font-size:13px;color:#64748b;margin-bottom:16px;">
                    "<b>{{ deleteTarget.name }}</b>" will be removed and all candidate assignments to it will be cleared.
                </div>
                <div style="display:flex;gap:8px;">
                    <button @click="deleteTarget=null" class="btn btn-sm" style="flex:1;background:#f1f5f9;color:#1e293b;border:none;border-radius:8px;">Cancel</button>
                    <button @click="confirmDelete" :disabled="deletingCenter" class="btn btn-sm btn-danger" style="flex:1;border-radius:8px;">
                        <span v-if="deletingCenter" class="spinner-border spinner-border-sm me-1"></span>
                        Delete
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '../../services/user.service';

export default {
    name: 'QhlsFinalExamCenterMgmt',
    data() {
        return {
            tab: 'centers',
            user_level: 2,
            // Centers list
            centers: [],
            loadingCenters: false,
            pdfExportingId: null,
            // Add form
            newCenter: {
                name: '', name_en: '', location: '', district_id: '',
                coordinator_name: '', coordinator_mobile: '', coordinator_user_id: null,
                invigilator_name: '', invigilator_mobile: '', invigilator_user_id: null,
            },
            addingCenter: false,
            // Edit modal
            editTarget: null,
            editForm: {},
            savingEdit: false,
            // Delete modal
            deleteTarget: null,
            deletingCenter: false,
            // Assign tab
            qualified: [],
            loadingQ: false,
            qualifiedLoaded: false,
            districts: [],
            zones: [],
            qhlsCenters: [],
            f_district: '',
            f_zone: '',
            f_center: '',
            q_search: '',
            // Report tab (state only)
            reportCandidates: [],
            reportLoaded: false,
            loadingReport: false,
            report_center_filter: 'all',
            report_district_filter: 'all',
            report_search: '',
        };
    },
    computed: {
        // Distinct districts present in the qualified list, with counts.
        reportDistrictOptions() {
            const counts = {};
            this.reportCandidates.forEach(c => {
                const d = (c.district_name || '').trim();
                if (d) counts[d] = (counts[d] || 0) + 1;
            });
            return Object.keys(counts).sort().map(name => ({ name, count: counts[name] }));
        },
        // Candidates scoped by the selected district (base for cards + centre list).
        reportScopedCandidates() {
            if (this.report_district_filter === 'all') return this.reportCandidates;
            return this.reportCandidates.filter(c => (c.district_name || '') === this.report_district_filter);
        },
        reportAssignedCount() {
            return this.reportScopedCandidates.filter(c => c.final_center_id).length;
        },
        reportNotAssignedCount() {
            return this.reportScopedCandidates.filter(c => !c.final_center_id).length;
        },
        reportPerCenter() {
            // count of assigned candidates per center (within the district scope)
            const counts = {};
            this.reportScopedCandidates.forEach(c => {
                if (c.final_center_id) counts[c.final_center_id] = (counts[c.final_center_id] || 0) + 1;
            });
            return this.centers
                .map(c => ({ id: c.id, name: c.name, count: counts[c.id] || 0 }))
                .filter(c => c.count > 0)
                .sort((a, b) => b.count - a.count);
        },
        reportFilteredCandidates() {
            let list = this.reportScopedCandidates;
            if (this.report_center_filter === 'unassigned') {
                list = list.filter(c => !c.final_center_id);
            } else if (this.report_center_filter !== 'all') {
                list = list.filter(c => c.final_center_id == this.report_center_filter);
            }
            const q = this.report_search.trim().toLowerCase();
            if (q) {
                const qDigits = q.replace(/\D/g, '');
                list = list.filter(item => {
                    const name = (item.name || '').toLowerCase();
                    const mobile = (item.mobile || '').replace(/\D/g, '');
                    return name.includes(q) || (qDigits.length > 0 && mobile.includes(qDigits));
                });
            }
            return list;
        },
        filteredQualified() {
            const q = this.q_search.trim().toLowerCase();
            if (!q) return this.qualified;
            const qDigits = q.replace(/\D/g, '');
            return this.qualified.filter(item => {
                const name = (item.name || '').toLowerCase();
                const mobile = (item.mobile || '').replace(/\D/g, '');
                const nameMatch = name.includes(q);
                const mobileMatch = qDigits.length > 0 && mobile.includes(qDigits);
                return nameMatch || mobileMatch;
            });
        },
    },
    mounted() {
        this.$store.dispatch('setPageHeader', 'QHLS Final Exam Centers');
        const currentUser = this.$store.state.auth.user;
        this.user_level = parseInt((currentUser && currentUser.user_level) || 2);
        this.loadCenters();
        if (this.user_level === 1) {
            this.loadDistricts();
            this.loadZones();
            this.loadQhlsCenters();
        }
    },
    methods: {
        tabStyle(active) {
            return active ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;';
        },

        // ---- Centers CRUD ----
        loadCenters() {
            this.loadingCenters = true;
            UserService.authPostRequest('get-qhls-final-exam-centers', {}).then(r => {
                this.loadingCenters = false;
                if (r.data.status === 'success') this.centers = r.data.data.list || [];
            }).catch(() => { this.loadingCenters = false; });
        },
        exportCandidatesPdf(c) {
            this.pdfExportingId = c.id;
            UserService.authGetRequest('export-qhls-final-exam-center-candidates', { center_id: c.id }, { responseType: 'blob' }).then(
                (response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `qhls-final-candidates-${(c.name || 'center').replace(/[^a-z0-9]+/gi, '_')}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                    this.pdfExportingId = null;
                },
                () => {
                    this.pdfExportingId = null;
                    window.alert('Failed to generate PDF.');
                }
            );
        },
        addCenter() {
            if (!this.newCenter.name.trim()) return;
            this.addingCenter = true;
            UserService.authPostRequest('add-qhls-final-exam-center', {
                name:                 this.newCenter.name.trim(),
                name_en:              this.newCenter.name_en.trim(),
                location:             this.newCenter.location.trim(),
                district_id:          this.newCenter.district_id || null,
                coordinator_name:     this.newCenter.coordinator_name,
                coordinator_mobile:   this.newCenter.coordinator_mobile,
                coordinator_user_id:  this.newCenter.coordinator_user_id,
                invigilator_name:     this.newCenter.invigilator_name,
                invigilator_mobile:   this.newCenter.invigilator_mobile,
                invigilator_user_id:  this.newCenter.invigilator_user_id,
            }).then(r => {
                this.addingCenter = false;
                if (r.data.status === 'success') {
                    this.centers.push(r.data.data.center);
                    this.newCenter = {
                        name: '', name_en: '', location: '', district_id: '',
                        coordinator_name: '', coordinator_mobile: '', coordinator_user_id: null,
                        invigilator_name: '', invigilator_mobile: '', invigilator_user_id: null,
                    };
                } else if (r.data.message) {
                    window.alert(r.data.message);
                }
            }).catch(() => { this.addingCenter = false; });
        },
        openEdit(c) {
            this.editTarget = c;
            this.editForm = {
                id:                  c.id,
                name:                c.name || '',
                name_en:             c.name_en || '',
                location:            c.location || '',
                coordinator_name:    c.coordinator_name || '',
                coordinator_mobile:  c.coordinator_mobile || '',
                coordinator_user_id: c.coordinator_user_id || null,
                invigilator_name:    c.invigilator_name || '',
                invigilator_mobile:  c.invigilator_mobile || '',
                invigilator_user_id: c.invigilator_user_id || null,
            };
        },
        saveEdit() {
            if (!this.editForm.name.trim()) return;
            this.savingEdit = true;
            UserService.authPostRequest('update-qhls-final-exam-center', {
                id:                  this.editForm.id,
                name:                this.editForm.name.trim(),
                name_en:             (this.editForm.name_en || '').trim(),
                location:            this.editForm.location.trim(),
                coordinator_name:    this.editForm.coordinator_name,
                coordinator_mobile:  this.editForm.coordinator_mobile,
                coordinator_user_id: this.editForm.coordinator_user_id,
                invigilator_name:    this.editForm.invigilator_name,
                invigilator_mobile:  this.editForm.invigilator_mobile,
                invigilator_user_id: this.editForm.invigilator_user_id,
            }).then(r => {
                this.savingEdit = false;
                if (r.data.status === 'success') {
                    const idx = this.centers.findIndex(c => c.id === this.editForm.id);
                    if (idx !== -1) this.centers.splice(idx, 1, r.data.data.center);
                    this.editTarget = null;
                }
            }).catch(() => { this.savingEdit = false; });
        },
        deleteCenter(center) { this.deleteTarget = center; },
        confirmDelete() {
            this.deletingCenter = true;
            const id = this.deleteTarget.id;
            UserService.authPostRequest('delete-qhls-final-exam-center', { id }).then(r => {
                this.deletingCenter = false;
                if (r.data.status === 'success') {
                    this.centers = this.centers.filter(c => c.id !== id);
                    this.deleteTarget = null;
                    this.qualified.forEach(q => { if (q.final_center_id === id) q.final_center_id = null; });
                }
            }).catch(() => { this.deletingCenter = false; });
        },
        // ---- Assign tab ----
        switchToAssign() {
            this.tab = 'assign';
            if (this.user_level !== 1 && !this.qualifiedLoaded) this.loadQualified();
        },
        // ---- Report tab (state) ----
        switchToReport() {
            this.tab = 'report';
            // Reload each time so newly-assigned candidates are reflected
            this.loadReport();
        },
        loadReport() {
            this.loadingReport = true;
            this.reportLoaded = false;
            this.report_district_filter = 'all';
            this.report_center_filter = 'all';
            this.report_search = '';
            // Load ALL qualified candidates state-wide (no district/zone/center filter)
            UserService.authPostRequest('get-qhls-final-qualified-with-centers', {
                district_id: null, zone_id: null, center_id: null,
            }).then(r => {
                this.loadingReport = false;
                this.reportLoaded = true;
                if (r.data.status === 'success') {
                    this.reportCandidates = r.data.data.list || [];
                }
            }).catch(() => { this.loadingReport = false; this.reportLoaded = true; });
        },
        centerNameById(id) {
            if (!id) return 'Not Assigned';
            const c = this.centers.find(c => c.id == id);
            return c ? c.name : 'Assigned';
        },
        loadDistricts() {
            UserService.authGetRequest('get-districts').then(r => {
                if (r.data.status === 'success') this.districts = r.data.data.list || r.data.data || [];
            });
        },
        onFDistrictChange() {
            this.f_zone = ''; this.f_center = ''; this.zones = []; this.qhlsCenters = [];
            if (this.f_district) this.loadZones();
        },
        loadZones() {
            const params = this.f_district ? { district_id: this.f_district } : {};
            UserService.authGetRequest('get-zones', params).then(r => {
                if (r.data.status === 'success') this.zones = r.data.data.list || r.data.data || [];
            });
        },
        onFZoneChange() {
            this.f_center = ''; this.qhlsCenters = [];
            if (this.f_zone) this.loadQhlsCenters();
        },
        loadQhlsCenters() {
            const params = {};
            if (this.f_zone) params.zone_id = this.f_zone;
            else if (this.f_district) params.district_id = this.f_district;
            UserService.authGetRequest('get-qhls-centers', params).then(r => {
                if (r.data.status === 'success') this.qhlsCenters = r.data.data.list || r.data.data || [];
            });
        },
        loadQualified() {
            this.loadingQ = true;
            this.qualifiedLoaded = false;
            this.q_search = '';
            UserService.authPostRequest('get-qhls-final-qualified-with-centers', {
                district_id: this.f_district || null,
                zone_id:     this.f_zone     || null,
                center_id:   this.f_center   || null,
            }).then(r => {
                this.loadingQ = false;
                this.qualifiedLoaded = true;
                if (r.data.status === 'success') {
                    this.qualified = (r.data.data.list || []).map(q => ({ ...q, _saving: false, _saved: false }));
                }
            }).catch(() => { this.loadingQ = false; this.qualifiedLoaded = true; });
        },
        assignCandidate(item) {
            item._saving = true; item._saved = false;
            UserService.authPostRequest('assign-qhls-final-exam-center', {
                registration_id: item.registration_id,
                center_id:       item.final_center_id || null,
            }).then(r => {
                item._saving = false;
                if (r.data.status === 'success') {
                    item._saved = true;
                    const c = this.centers.find(c => c.id == item.final_center_id);
                    item.final_center_name = c ? c.name : null;
                    setTimeout(() => { item._saved = false; }, 2000);
                }
            }).catch(() => { item._saving = false; });
        },
    },
};
</script>

<style scoped>
@keyframes spin { to { transform: rotate(360deg); } }
.field-label { font-size: 11px; font-weight: 600; color: #64748b; margin-bottom: 3px; display: block; }

/* Compact tab buttons */
.qtab {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    min-height: 46px;
    padding: 7px 4px;
    border: none;
    border-radius: 10px;
    font-size: 11.5px;
    font-weight: 700;
    line-height: 1.15;
    text-align: center;
    cursor: pointer;
}
.qtab ion-icon { font-size: 17px; }

/* Compact summary cards */
.rcard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    border: 1px solid transparent;
    border-radius: 10px;
    padding: 9px 11px;
    min-height: 58px;
}
.rcard-label { font-size: 10.5px; font-weight: 700; line-height: 1.2; }
.rcard-num { font-size: 22px; font-weight: 900; line-height: 1; }
</style>
